import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BrandIconSpinner, CustomPopover, Modal } from 'components';
import { companySizeList, ProfileLimit } from 'assert/OptionList';
import { ProfileContainer } from 'pages/profile/Profiles.style';
import { getProfileByuserName } from 'redux/features/ProfileSlice';
import { getEducationByuserId } from 'redux/features/EducationSlice';
import { getExperienceByuserId } from 'redux/features/ExperienceSlice';
import { PostBox } from 'pages/home/Home.style';
import { getSkillsByuserId } from 'redux/features/SkillSlice';
import {
  PersonalContainer,
  PStrengthPopOver,
} from 'pages/addprofile/AddProfile.style';
import SkillForms from 'pages/addprofile/Skills';
import Experiences from 'pages/addprofile/Experience';
import Educations from 'pages/addprofile/Education';
import PersonalDetails from 'pages/addprofile/PersonalDetails';
import Profile from 'pages/addprofile/Profile';
import { ProfileCard } from 'pages/addprofile/ProfileCard';
import ProfileContent from './ProfileContent';
import Summary from 'pages/addprofile/Summary';
import AddMoreSection from 'pages/addprofile/AddMoreSection';
import { getaddMoreByuserId } from 'redux/features/AddMoreSectionSlice';
import CompanyDetails from 'pages/addprofile/CompanyDetails';
import {
  getCompanyImagesList,
  getCompanyProfileByuserId,
} from 'redux/features/CompanySlice';
import CompanyImages from 'pages/addprofile/CompanyImages';
import {
  ExperienceList,
  SkillContainer,
  NoProfile,
  ProfileLoaderContainer,
} from 'pages/addprofile/Profile.style';
import clsx from 'clsx';
import {
  getCountryList,
  getJobTypeList,
  getWorkTypeList,
} from 'redux/features/DropDownSlice';
import CustomCarousel from 'components/CustomCarousel';
import { ReactComponent as Info } from 'assert/images/More/info.svg';
import { ReactComponent as Tick } from 'assert/images/Profile/tick.svg';
import { useLocation } from 'react-router-dom';
import {
  handleOpenLinkInBrower,
  swipeModalWidth,
  yearofExperience,
} from 'utils/helper';
import { Helmet } from 'react-helmet';
import BasicChips from 'components/Chip';
import useWindowDimensions from 'components/Dimention';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';

const Profiles = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { getSkills } = useSelector((state) => state?.SkillsSlice);
  const getProfile = useSelector(
    (state) => state?.ProfileSlice?.currentProfile
  );
  const loginProfileData = useSelector(
    (state) => state?.ProfileSlice?.getProfile
  );
  const { getEducation } = useSelector((state) => state?.EducationSlice);
  const { getExperience } = useSelector((state) => state?.ExperienceSlice);
  const { getaddMore } = useSelector((state) => state?.AddMoreSlice);
  const { getCmyProfile, getCmyImages } = useSelector(
    (state) => state?.CompanySlice
  );
  const { workTypeList, jobList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  const userId = getProfile?.userId;
  const getUsername = location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();

  const [typeInfo, setTypeInfo] = useState();
  const [openPopover, setOpenPopover] = useState();
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState({
    personal: [],
    skills: [],
    education: [],
    experience: [],
    addmore: [],
    company: [],
    companyImages: [],
    expendSkills: false,
    expendExperience: false,
    expendEducation: false,
    expendAddmore: false,
  });
  const [personalDetails, setPersonalDetails] = useState({
    profile: {
      modal: false,
      details: [],
    },
    subProfile: {
      modal: false,
      details: [],
    },
    personal: {
      modal: false,
      details: [],
    },
    skills: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
    summary: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
    addmore: {
      details: [],
    },
    education: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
    experience: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
    company: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
    companyImages: {
      modal: false,
      details: [],
      action: false,
      title: 'Add',
    },
  });

  useEffect(() => {
    jobList?.length === 0 && dispatch(getJobTypeList());
    workTypeList?.length === 0 && dispatch(getWorkTypeList());
    countryList?.length === 0 && dispatch(getCountryList());
  }, []);

  useEffect(() => {
    setLoading(true);
    currentUsername &&
      dispatch(getProfileByuserName())
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
  }, [currentUsername]);

  useEffect(() => {
    if (getProfile?.accountType === 0 && getProfile?.isBlocked !== 1) {
      dispatch(getEducationByuserId());
      dispatch(getExperienceByuserId());
      dispatch(getSkillsByuserId());
      dispatch(getaddMoreByuserId());
    } else if (getProfile?.accountType === 1 && getProfile?.isBlocked !== 1) {
      dispatch(getCompanyImagesList(getProfile?.username));
      dispatch(getCompanyProfileByuserId(getProfile?.username));
    }
  }, [currentUsername, userId, getProfile?.accountType]);

  useEffect(() => {
    personalDetails.personal.details = getProfile && getProfile;
    personalDetails.skills.details = (getSkills && getSkills[0]?.data) || [];
    personalDetails.experience.details =
      (getExperience && getExperience[0]?.data) || [];
    personalDetails.education.details =
      (getEducation && getEducation[0]?.data) || [];
    personalDetails.addmore.details = (getaddMore && getaddMore[0]?.data) || [];
    personalDetails.company.details =
      (getCmyProfile && getCmyProfile?.[0]) || [];
    personalDetails.companyImages.details = getCmyImages || [];
    setPersonalDetails((prevState) => ({
      ...prevState,
    }));

    profileData.personal = getProfile && getProfile;
    profileData.experience = getExperience && getExperience[0];
    profileData.education = getEducation && getEducation[0];
    profileData.addmore = getaddMore && getaddMore?.[0]?.data;
    profileData.company = getCmyProfile && getCmyProfile;
    profileData.companyImages = getCmyImages || [];
    setProfileData((prevState) => ({
      ...prevState,
    }));
  }, [
    getSkills,
    getEducation,
    getExperience,
    getProfile,
    getaddMore,
    getCmyProfile,
    getCmyImages,
  ]);

  const updateUserDetails = useCallback((data) => {
    setTypeInfo(data);
    personalDetails[data].modal = true;
    personalDetails[data].action = personalDetails[data].details?.length !== 0;
    personalDetails[data].title =
      personalDetails[data].details?.length === 0 ? 'Add' : 'Edit';
    setPersonalDetails((prevState) => ({
      ...prevState,
    }));
  }, []);

  const closePostModal = useCallback((data, type) => {
    personalDetails[type].modal = data;
    setPersonalDetails((prevState) => ({
      ...prevState,
    }));
  }, []);

  const changeAction = useCallback((data, type) => {
    personalDetails[type].action = data;
    setPersonalDetails((prevState) => ({
      ...prevState,
    }));
  }, []);

  const changeTitle = useCallback((data, type) => {
    personalDetails[type].title = data;
    setPersonalDetails((prevState) => ({
      ...prevState,
    }));
  }, []);

  const getContent = (data) => {
    const list = yearofExperience();
    switch (data) {
      case 'profile':
        return (
          <Profile
            typeInfo={typeInfo}
            profileImages={profileData?.personal}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'personal':
        return (
          <PersonalDetails
            personalData={personalDetails[data]}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'summary':
        return (
          <Summary
            profileData={profileData}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'skills':
        return <SkillForms list={list} />;
      case 'education':
        return (
          <Educations
            educationsData={personalDetails[data]}
            changeAction={(data, type) => changeAction(data, type)}
            changeTitle={(data, type) => changeTitle(data, type)}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'experience':
        return (
          <Experiences
            experiencesData={personalDetails[data]}
            changeAction={(data, type) => changeAction(data, type)}
            changeTitle={(data, type) => changeTitle(data, type)}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'company':
        return (
          <CompanyDetails
            personalData={personalDetails[data]}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      case 'companyImages':
        return (
          <CompanyImages
            personalData={personalDetails[data]}
            onClose={(data, type) => closePostModal(data, type)}
          />
        );
      default:
        return null;
    }
  };

  const CardExpandFun = (val, key) => {
    setProfileData((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleModalTitle = () => {
    switch (typeInfo) {
      case 'profile':
        return typeInfo;
      case 'personal':
        return t('profile.PersonalDetails');
      case 'summary':
        return t('profile.Summary');
      case 'skills':
        return t('profile.Skills');
      case 'education':
        return t('profile.Education');
      case 'experience':
        return t('profile.Experience');
      // case 'addmore':
      //   return 'More Section';
      case 'company':
        return t('profile.AboutUs');
      case 'companyImages':
        return t('profile.Memories');
      default:
        return null;
    }
  };

  const personalData = personalDetails?.personal?.details;
  const personalSkills = personalDetails?.skills?.details;
  const companyData = personalDetails?.company?.details;
  const handleTrueCount = () => {
    const progressValue = [
      !!personalData?.coverImage,
      !!personalData?.profileImage,
      !!personalData?.gender,
      !!profileData?.personal?.summary,
      !!personalSkills?.length > 0,
      !!personalDetails?.experience?.details?.length > 0,
      !!personalDetails?.education?.details?.length > 0,
    ];
    return progressValue.sort((a, b) => (a === b ? 0 : a ? -1 : 1));
  };
  const totalCount = handleTrueCount().filter((value) => value === true).length;

  const handleGetProgressStrength = () => {
    return (
      <div className="progress-btn">
        {handleTrueCount().map((bol, index) => {
          return <div key={index} className={clsx(bol && 'progress-green')} />;
        })}
      </div>
    );
  };

  const profileStrengthDropdown = () => {
    const progressValue = [
      { label: 'Cover Image', value: !!personalData?.coverImage },
      { label: 'Profile Image', value: !!personalData?.profileImage },
      { label: 'Profile', value: !!personalData?.gender },
      { label: 'Summary', value: !!profileData?.personal?.summary },
      { label: 'Skills', value: !!personalSkills?.length > 0 },
      {
        label: 'Experience',
        value: !!personalDetails?.experience?.details?.length > 0,
      },
      {
        label: 'Education',
        value: !!personalDetails?.education?.details?.length > 0,
      },
    ];
    return (
      <PStrengthPopOver>
        {progressValue.map((bol, index) => {
          return (
            <div key={index} className="progress-details">
              <div>{bol.label}</div>
              <div>{bol.value && <Tick />}</div>
            </div>
          );
        })}
      </PStrengthPopOver>
    );
  };

  if (getProfile?.isBlocked === 1) {
    return <NoProfile>This profile is no longer available</NoProfile>;
  }

  if (loading || !getProfile?.userId) {
    return (
      <ProfileLoaderContainer>
        <BrandIconSpinner loading />
      </ProfileLoaderContainer>
    );
  } else {
    return (
      <>
        <Helmet>
          <title>
            {getProfile?.username
              ? `${
                  getProfile.username.length > 50
                    ? getProfile.username.slice(0, 50) + '... | WafyNet'
                    : getProfile.username + ' | WafyNet'
                }`
              : 'User Profile | WafyNet'}
          </title>
          <meta
            name="description"
            content={
              getProfile?.summary
                ? getProfile.summary
                : 'View user profiles, connect with professionals, and grow your network on WafyNet.'
            }
          />
        </Helmet>
        <PostBox className="profile-page-container">
          <ProfileContainer>
            <ProfileContent
              profileImages={profileData?.personal}
              companyData={companyData}
              showEdit={
                loginProfileData?.username ===
                decodeURIComponent(currentUsername)
              }
              updateDetails={() => updateUserDetails('personal')}
            />

            {getProfile?.accountType === 0 && (
              <>
                {loginProfileData?.username ===
                  decodeURIComponent(currentUsername) &&
                  totalCount !== 7 && (
                    <div className="profile-strength-container">
                      <div className="profile-strength">
                        {t('profile.ProfileStrength')}
                        {totalCount <= 3 ? (
                          <div className="strength-low">{t('profile.Low')}</div>
                        ) : (
                          <div className="strength-medium">
                            {t('profile.Medium')}
                          </div>
                        )}
                        <CustomPopover
                          isOpen={openPopover}
                          handlePopoverClick={() => setOpenPopover(true)}
                          action={<Info className="profile-strength-info" />}
                          content={profileStrengthDropdown()}
                        />
                      </div>
                      {handleGetProgressStrength()}
                    </div>
                  )}
                {(loginProfileData?.username ===
                  decodeURIComponent(currentUsername) ||
                  profileData?.personal?.summary) && (
                  <ProfileCard
                    title={t('profile.Summary')}
                    updateDetails={() => updateUserDetails('summary')}
                    content={
                      <SkillContainer>
                        {profileData?.personal?.summary}
                      </SkillContainer>
                    }
                  />
                )}
                {(loginProfileData?.username ===
                  decodeURIComponent(currentUsername) ||
                  personalSkills?.length > 0) && (
                  <ProfileCard
                    title={t('profile.Skills')}
                    FooterSection={!profileData.expendSkills}
                    ExpendFun={(bln) => CardExpandFun(bln, 'expendSkills')}
                    ItemsLength={personalSkills?.length}
                    updateDetails={() => updateUserDetails('skills')}
                    customMaxLength={100}
                    content={
                      <SkillContainer>
                        <div className="profile-show-skills">
                          {personalSkills?.length > 0 &&
                            personalSkills.map((data) => {
                              return (
                                <div key={data.skill}>
                                  <BasicChips
                                    label={
                                      data?.experience
                                        ? data?.skill + ' - ' + data.experience
                                        : data?.skill
                                    }
                                  />
                                </div>
                              );
                            })}
                        </div>
                      </SkillContainer>
                    }
                  />
                )}
                {(loginProfileData?.username ===
                  decodeURIComponent(currentUsername) ||
                  personalDetails?.experience?.details?.length > 0) && (
                  <ProfileCard
                    title={t('profile.Experience')}
                    FooterSection={!profileData?.expendExperience}
                    ExpendFun={(bln) => CardExpandFun(bln, 'expendExperience')}
                    ItemsLength={profileData?.experience?.data?.length}
                    updateDetails={() => updateUserDetails('experience')}
                    content={
                      <ExperienceList>
                        {personalDetails?.experience?.details?.length > 0 &&
                          personalDetails?.experience?.details
                            ?.slice(
                              0,
                              profileData?.expendExperience
                                ? personalDetails?.experience?.details?.length
                                : 3
                            )
                            ?.map((data) => {
                              return (
                                <div className="show-exp-list" key={data.id}>
                                  <div
                                    className={clsx(
                                      'exp-title',
                                      'exp-list-title'
                                    )}
                                  >
                                    <div className="role">{data.title}</div>
                                    <div className="exp-date">
                                      {data.startDate +
                                        ' ' +
                                        (data.endDate
                                          ? `- ${data?.endDate}`
                                          : '- Present')}
                                    </div>
                                  </div>
                                  <div className="sub-data">
                                    {data.companyName}
                                    {data.location ? ', ' + data.location : ''}
                                  </div>
                                  <div className="sub-data-flex">
                                    {
                                      workTypeList.find(
                                        (workTypeItem) =>
                                          workTypeItem.value ===
                                          Number(data.workType)
                                      )?.label
                                    }
                                    {data.employmentType ? (
                                      <>
                                        <span> • </span>{' '}
                                        <div>
                                          {
                                            jobList.find(
                                              (employmentItem) =>
                                                employmentItem.value ===
                                                Number(data.employmentType)
                                            )?.label
                                          }
                                        </div>
                                      </>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  {data?.description !== '' && (
                                    <div
                                      className={'description-section'}
                                      dangerouslySetInnerHTML={{
                                        __html: data?.description,
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            })}
                      </ExperienceList>
                    }
                  />
                )}
                {(loginProfileData?.username ===
                  decodeURIComponent(currentUsername) ||
                  personalDetails?.education?.details?.length > 0) && (
                  <ProfileCard
                    title={t('profile.Education')}
                    FooterSection={!profileData.expendEducation}
                    ExpendFun={(bln) => CardExpandFun(bln, 'expendEducation')}
                    ItemsLength={profileData.education?.data?.length}
                    updateDetails={() => updateUserDetails('education')}
                    content={
                      <ExperienceList>
                        {personalDetails?.education?.details?.length > 0 &&
                          personalDetails?.education?.details
                            ?.slice(
                              0,
                              profileData.expendEducation
                                ? personalDetails?.education?.details.length
                                : 3
                            )
                            ?.map((data, index) => {
                              return (
                                <div key={index} className="show-exp-list">
                                  <div
                                    className={clsx(
                                      'exp-title',
                                      'exp-list-title'
                                    )}
                                  >
                                    <div className="role">
                                      {data.schoolCollege}
                                    </div>
                                    <div className="exp-date">
                                      {data.startDate +
                                        ' ' +
                                        (data.endDate
                                          ? `- ${data?.endDate}`
                                          : '- Present')}
                                    </div>
                                  </div>
                                  <div className="sub-data-flex degree-container">
                                    {data.degree}
                                    {data.fieldOfStudies ? (
                                      <>
                                        <span> • </span>{' '}
                                        <div>{data.fieldOfStudies}</div>
                                      </>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  <div className="sub-data-flex">
                                    {data.otherDetails}
                                  </div>
                                </div>
                              );
                            })}
                      </ExperienceList>
                    }
                  />
                )}
                {ProfileLimit.addmoreLimit >=
                  Number(personalData?.details?.length || 0) && (
                  <AddMoreSection
                    addMoreList={personalDetails?.addmore?.details}
                  />
                )}
              </>
            )}
            {getProfile?.accountType === 1 && (
              <>
                <ProfileCard
                  title={t('profile.Memories')}
                  showIcons
                  updateDetails={() => updateUserDetails('companyImages')}
                  content={
                    <CustomCarousel
                      items={profileData?.companyImages?.[0]?.image}
                    />
                  }
                />
                <ProfileCard
                  title={t('About Us')}
                  updateDetails={() => updateUserDetails('company')}
                  content={
                    <PersonalContainer>
                      <div className="personal-list">
                        <div
                          className="cmy-name-url"
                          onClick={() =>
                            handleOpenLinkInBrower(companyData?.url)
                          }
                        >
                          {companyData?.name}
                        </div>
                        <div>
                          {
                            companySizeList.find(
                              (size) => size.value === companyData?.size
                            )?.label
                          }
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: companyData?.descriptions,
                          }}
                        />
                      </div>
                    </PersonalContainer>
                  }
                />
              </>
            )}
            {isSmallScreen ? (
              <SwipeableEdgeDrawer
                title={handleModalTitle()}
                openDrawer={personalDetails[typeInfo]?.modal}
                handleCloseDrawer={() => closePostModal(false, typeInfo)}
              >
                {getContent(typeInfo)}
              </SwipeableEdgeDrawer>
            ) : (
              <Modal
                content={getContent(typeInfo)}
                modalchanges={'commonModal'}
                openModal={personalDetails[typeInfo]?.modal}
                modelTitle={handleModalTitle()}
                handleCancelModal={() => closePostModal(false, typeInfo)}
              />
            )}
          </ProfileContainer>
        </PostBox>
      </>
    );
  }
};
export default Profiles;
